require('features/routing');
require('features/segment');
require('features/googleAnalytics4');
require('features/articleSearchBox');
require('features/articleCardCarousel');

require('./components/lifestyleInsightsSection');
require('./components/eventTracking/segmentEventsHandler');
require('./components/eventTracking/googleAnalytics4EventsHandler');

// ugly injection for those components, after rebrand this will be
// removed once the listing for you section is moved to its own page
require('../../blog/components/listingsForYouSection');
require('../../blog/handlers/hyperlinkCardHandler');
require('../../newsAndTrends/handlers/hamburgerMenuHandler');
